import React, { useState } from 'react'
import { styled } from '@mui/system';
import { Typography, Checkbox, FormControlLabel, Box } from '@mui/material';
import { useNavigate, } from "react-router-dom";
import NavBar from '../NavBar/NavBar';
import { getUserDetails } from '../HomePage/userManagement';
import EmailAvatar from '../HomePage/EmailAvatar';

const MainContainer = styled('div')({
    height: "100vh",
    display: 'flex',
});
const Half2 = styled('div')({
    width: '20%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    borderRight: '2.5px solid #D8D0D0',
    borderBottom: '2.5px solid #D8D0D0',
    background: '#fafafa',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
});
const ContentHalf = styled('div')({
    flex: 1,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: '15px',
    overflowY: 'auto'
});
const GenerateButton2 = styled('button')({
    backgroundColor: '#2560CD',
    padding: '10px 26px',
    color: 'white',
    cursor: 'pointer',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    borderRadius: '10px',
    '&:hover': {
        background: 'black',
        color: 'white',
        transform: 'scale(1.1)',
    },
});

const respon = [
    { key: 'Project Management', label: 'I have efficiently executed end-to-end projects from inception to conclusion.' },
    { key: 'Design and Visualization', label: 'I have created unique and impactful visuals such as sketches, designs, art forms etc that have generated positive comments & feedback.' },
    { key: 'Negotiations and Deal Making', label: 'I have been a part of discussions involving lead generation and conversion to reach targets and goals.' },
    { key: 'Marketing and Promotions', label: 'I have exerted influence through social media, endorsed content, products, handled marketing & promotions or managed events.' },
    { key: 'Critical Thinking and Problem Solving', label: 'I have assessed situations, explored solutions, and made decisions to navigate challenges during these activities.' },
    { key: 'Cross Cultural Engagements', label: 'I have worked with people from diverse backgrounds, languages and regions.' },
    { key: 'External Interactions', label: 'I have engaged with individuals external to the organization or institution.' },
    { key: 'Internal Interactions', label: 'I have engaged with individuals within the team, institution, or organization.' },
    { key: 'Numerical and Quantitative Aptitude', label: 'I have conducted numerical analyses, data interpretation, financial analysis, or quantitative calculations.' },
    { key: 'Resource Management', label: 'I have managed budgets, time, people, volunteers, and/or coordinated additional assistance in executing activities.' },
    { key: 'Analytics, Research and Insights', label: 'I have conducted research, analyzed data, observed trends, and derived insights.' },
    { key: 'Creation and Innovation', label: 'I have demonstrated creativity, innovative approaches or ideas, or developed functional prototypes.' },
    { key: 'Subject Matter Expertise', label: 'I have demonstrated expertise in particular areas, drawing upon my knowledge, experience, or training in various fields such as business, technology, music, arts, or sports.' },
    { key: 'Operations and Process Excellence', label: 'I have contributed to process enhancements, handled procurement, supply chain, or implemented improvements to existing systems and processes.' },
    { key: 'Recruitment and Support', label: 'I have helped onboard new team members, identified their learning needs, and supported them in getting up to speed.' },
    { key: 'Administration', label: 'I have provided team support through administrative tasks or comprehensive documentation.' },
    { key: 'Self Management and Development', label: 'I have kept an optimistic mindset, taken initiative, expanded my knowledge, remained driven, and adjusted to obstacles effectively' },
    { key: 'Dynamic Presence', label: 'I have engaged audience in public and high-visibility settings like public speaking, presentations and performances.' },
    { key: 'Social Initiatives and Impact', label: 'I have contributed to society through socially impactful activities.' },
    { key: 'Monitoring, Inspecting and Testing', label: 'I have tracked key metrics, analyzed trends to drive quality and compliance.' },
    { key: 'Leadership', label: 'I have exhibited leadership qualities by defining a vision, initiating actions, motivating team members, and achieving results in assigned activities.' }
];


const QuestionairePart1 = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedKeys, setSelectedKeys] = useState([]);
    const itemsPerPage = 6;
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    const handleButtonClick = (key) => {
        if (selectedKeys.includes(key)) {
            setSelectedKeys((prev) => prev.filter((item) => item !== key));
        } else {
            setSelectedKeys((prev) => [...prev, key]);
        }
    };

    const isButtonActive = (key) => selectedKeys.includes(key);

    const routePaths = [
        '/dashboard',
        '/userdetails',
        '/quetionairepart1',
        '/report',
    ];

    const activePageIndex = routePaths.indexOf('/userdetails');

    const handleNextPage = () => {
        if (currentPage < Math.ceil(respon.length / itemsPerPage) - 1) {
            setCurrentPage(currentPage + 1);
        }
        if (currentPage === 3) {
            if (selectedKeys.length === 0) {
                setErrorMessage("Please Select any one Aspect");
                setTimeout(() => {
                    setErrorMessage(null);
                }, 3000);
            } else {
                navigate('/quetionairepart2', { state: { selectedKeys } });
            }
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
        if (currentPage === 0) {
            navigate('/landingpage');
        }
    };

    return (
        <MainContainer>
            <Half2>
                <NavBar activePage={activePageIndex} user={getUserDetails} />
            </Half2>
            <ContentHalf>
                <div style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between', width: '92%' }}>
                    <Typography
                        color='black'
                        style={{
                            fontFamily: 'Poppins, sans-serif',
                            fontSize: '20px',
                            fontWeight: 600,
                            marginTop: '5%',
                            marginLeft: '8px',
                            marginBottom: 5
                        }}
                    >
                        In the context of your activities, please check all that apply
                    </Typography>
                    <EmailAvatar />
                </div>
                <div style={{ padding: '15px', width: '90%', color: 'black', border: '2px solid #D8D0D0', borderRadius: '12px', height: 'auto' }}>
                    {respon.slice(startIndex, endIndex).map(({ key, label }) => (
                        <Box sx={{ marginBottom: '10px', height: 'auto' }} key={key}>
                            <FormControlLabel
                                label={label}
                                style={{ fontFamily: 'Poppins, sans-serif', margin: 0, padding: 0 }}
                                control={
                                    <Checkbox
                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 35 }, }}
                                        onClick={() => handleButtonClick(key)}
                                        checked={isButtonActive(key)}
                                    />
                                }
                            />
                        </Box>
                    ))}
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
                        <GenerateButton2 onClick={handlePrevPage} >Previous</GenerateButton2>
                        {errorMessage && <p style={{ color: 'red', marginTop: '10px', textAlign: 'center' }}>{errorMessage}</p>}
                        <GenerateButton2 onClick={handleNextPage} >Next</GenerateButton2>
                    </div>
                </div>
            </ContentHalf>
        </MainContainer >
    )
}

export default QuestionairePart1;
